export type TBaseTokenData = {
  id: string;
  contractAddress: string;
  price: number;
  marketCap: number;
  totalVolume: number;
  holdersCount: number;
  isRisky: boolean;
  symbol?: string;
  name?: string;
  transactionsCount: number;
  twitterFollowers?: number;
  telegramMembers?: number;
  priceDifference: {
    isUp: boolean;
    price: number;
  };
  description?: string;
  homepageUrl?: string;
  pairCreatedAt?: Date;
  liquidityPoolStatus: LiquidityPoolStatusEnum;
  color?: string;
  imageUrl?: string;
  isSuitable: boolean;
};

export enum LiquidityPoolStatusEnum {
  LOCKED = 'LOCKED',
  UNLOCKED = 'UNLOCKED',
}

export type TTokenItem = {
  id: string;
  symbol: string;
  name: string | null;
  swapCount: number;
};

export type TVideoToken = {
  id: string;
  symbol: string;
  video: string;
  creatorUserId: number;
  img: string;
  contractAddress: string;
  creatorName: string;
};

export enum TutorialStatusEnum {
  ENDED = 'ended',
  ACTIVE = 'active',
  RESERVE = 'reserve',
}

export enum TokenCategory {
  VIDEO = 'VIDEO',
}

export enum LiquidityPoolStatus {
  LOCKED = 'LOCKED',
  UNLOCKED = 'UNLOCKED',
}

export enum BankStatus {
  REWARDS_OPENED = 'REWARDS_OPENED',
  REWARDS_CLOSED = 'REWARDS_CLOSED',
}

export interface ICategoryInfo {
  category: TokenCategory;
  lastUsedAt: string;
}

export interface IBank {
  id: string;
  investedAmount: number;
  investedAmountInUsd: number;
  investedAmountInSol: number;
  mcBound: number;
  maxUsersAmount: number;
  status: BankStatus;
  joinedUsersCount: number;
  createTxHash: string;
  userId: number;
  tokenId: string;
  createdAt: string;
  updatedAt: string;
}

export interface IToken {
  id: string;
  symbol: string;
  contractAddress: string;
  decimals: number;
  isNative: boolean;
  isWhiteListed: boolean;
  icon: string;
  img: string;
  img_watermark: string;
  video_watermark: string;
  video: string;
  video_m3u8: string;
  coingeckoId: string | null;
  pairCreatedAt: string;
  liquidityPoolStatus: LiquidityPoolStatus;
  categories: TokenCategory[];
  isSuitable: boolean;
  rejectionReasons: string[];
  color: string;
  description: string | null;
  telegramMembers: number | null;
  twitterFollowers: number | null;
  name: string;
  isRisky: boolean;
  categoriesInfo: ICategoryInfo[];
  homepageUrl: string | null;
  isAdmin: boolean;
  isPumpFun: boolean;
  isMeteora: boolean;
  isMintable: boolean;
  isFreezable: boolean;
  creatorUserId: number;
  views: number;
  hashedKey: string | null;
  createdAt: string;
  updatedAt: string;
  tutorialStatus: TutorialStatusEnum;
  reserveOrder: number | null;
  bank: IBank | null;
}
